import * as React from 'react';
import { NoSsr } from '@cian/react-utils';
import { clsx } from 'clsx';
import { valueToPercent } from '../helpers';
import styles from '../styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SliderMarks(props) {
  var values = props.values,
    marks = props.marks,
    min = props.min,
    max = props.max;
  var lastIndex = marks.length - 1;
  return /*#__PURE__*/_jsx(NoSsr, {
    children: marks.map(function (mark, index) {
      var value = mark.value,
        label = mark.label;
      var percent = valueToPercent(value, min, max);
      var style = {
        left: "".concat(percent, "%")
      };
      var isActive = getIsActive(value, values);
      var isFirst = index === 0;
      var isLast = index === lastIndex;
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          style: style,
          className: clsx(styles['mark'], isActive && styles['active'], isFirst && styles['first'], isLast && styles['last'])
        }), label && /*#__PURE__*/_jsx("span", {
          "aria-hidden": true,
          style: style,
          className: clsx(styles['mark-label'], isFirst && styles['first'], isLast && styles['last']),
          children: label
        })]
      }, value);
    })
  });
}
function getIsActive(value, values) {
  var isRange = values.length >= 2;
  if (isRange) {
    return value >= values[0] && value <= values[values.length - 1];
  }
  return value <= values[0];
}